<main class="flex-1 overflow-y-auto w-full h-full">
  @if (messages.length === 0) {
    <div class="flex flex-col items-center justify-center h-full">
      <img [src]="themeService.effectiveTheme() === 'dark' ? '/assets/media/app/logo_chat_dark.png' : '/assets/media/app/logo.png'" alt="Veraxum Logo" class="h-48 mb-6" />
      <h1 class="text-3xl font-semibold text-gray-400 dark:text-gray-500">Ask about anything</h1>
    </div>
  }
  
  @if (messages.length > 0) {
    <div>
      @for (msg of messages; track $index) {
        <div class="border-b border-gray-200 dark:border-gray-800">
          <!-- User Message -->
          @if (msg.role === 'user') {
            <div class="py-6 px-4 flex gap-4">
              <!-- User Icon -->
              <div class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center bg-blue-500 text-white">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path>
                </svg>
              </div>
              <div class="flex-grow pt-1 text-gray-800 dark:text-gray-100 whitespace-pre-line">
                <p>{{msg.content}}</p>
              </div>
            </div>
          }

          <!-- Agent Message -->
          @if (msg.role === 'agent') {
            <div class="py-6 px-4 flex gap-4 bg-gray-50 dark:bg-gray-800/50">
              <!-- Assistant Icon -->
              <div class="w-8 h-8 rounded-full flex-shrink-0 flex items-center justify-center bg-gray-700 dark:bg-gray-600 text-white">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z"></path>
                </svg>
              </div>
              <div class="flex-grow pt-1 text-gray-800 dark:text-gray-100 whitespace-pre-line">
                <!-- Trace Viewer -->
                <app-trace-viewer 
                  [traces]="msg.traces || []"
                  [isStreaming]="msg.isStreaming || false">
                </app-trace-viewer>

                <!-- Show error if present -->
                @if (msg.error) {
                  <div class="mb-4 p-3 bg-red-50 dark:bg-red-950/40 border border-red-200 dark:border-red-900 rounded-lg">
                    <p class="text-sm text-red-700 dark:text-red-300">⚠️ Error: {{msg.error}}</p>
                  </div>
                }

                <!-- Answer with Inline References -->
                @if (msg.data && msg.data.answer) {
                  <div>
                    <app-message-with-refs 
                      [text]="msg.data.answer"
                      [statements]="msg.data.statements || []"
                      (referenceClick)="inlineReferenceClick.emit($event)">
                    </app-message-with-refs>
                    
                    <!-- Optional: Show all references button (collapsible) -->
                    @if (msg.data.statements && msg.data.statements.length > 0) {
                      <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700">
                        <button
                          (click)="showAllResources.emit(msg.data.statements || [])"
                          class="text-sm bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600 px-3 py-1.5 rounded transition-colors flex items-center gap-2">
                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                          </svg>
                          View All References in Graph
                        </button>
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          }
        </div>
      }
      <div #messagesEnd></div>
    </div>
  }
</main>

